

function GridReference() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
			errors: '<fieldErrors',
		},
		controller: function($parse, $scope, FormService, $q, Classes) {
			var self = this;
			
			this.setupObjects = function(objects) {
				this.items = [];
				this.loaded_objects = objects;
				var newitems = [];
				var target_identity = (self.field.client && self.field.client.identity)? self.field.client.identity : '__vid';
				for (var i=0; i<objects.length; i++) {
					(function(target){
						var current_object = null;
						var object_index = null;
						if (self.object[self.field.name] && self.object[self.field.name].length) {
							for (var i=0; i<self.object[self.field.name].length; i++) {
								var item = self.object[self.field.name][i];
								if (item[self.field.join.aheadref] == target
									|| target_identity && item[self.field.join.aheadref] && item[self.field.join.aheadref][target_identity] == target[target_identity]) {
									current_object = item;
									object_index = i;
								}
							}
						}
						var item = {
							value: current_object,
							title: self.getObjectTitle(target),
							selected: current_object != null || (self.field.client && self.field.client.autoselect_all),
							object: target,
							error_index: null,
							clear: function() {
								return FormService.fetchDefaultInstance(self.field.fields).then(function(instance){
									instance.__title = target.__title;
									if (self.field.join.foreignClass) {
										instance = Classes[self.field.join.foreignClass].create(instance)
									}
									Object.defineProperty(instance, self.field.join.aheadref, {
										enumerable: false,
										configurable: true,
										writable: false,
										value: (target.__class && Classes[target.__class])? Classes[target.__class].getObjectPayload(target) : target
									});
									item.value = instance;
									return instance;
								})
							}
						}
						if (!self.errorInitialized) {
							item.error_index = object_index;
						}
						if (!current_object) {
							newitems.push(item.clear())
						}
						self.items.push(item)
					})(objects[i])
				}
				$q.all(newitems).then(function(){
					self.dictInitialized = true;
					self.errorInitialized = true;
				})
			}

			/* begin same as dictionary */

			this.getObjectTitle = function(object) {
				if (this.field.client && this.field.client.title) {
					var title_expr = this.field.client.title;
					var title = $parse(title_expr);
					return title(object, window);
				} else {
					return object? object.__title : null;
				}
			}

			this.items = [];
			this.loaded_objects = [];
			this.errorInitialized = false;
			this.dictInitialized = false;
			this.dictRequestEssentialDataJson = null;  // aby sprawdzać, czy trzeba robić reload dict
			this.reloadDict = false;
			this.isDictLoading = false;
			
			this.getEssentialData = function() {
				if (this.object.__class && Classes[this.object.__class]) {
					var klass = Classes[this.object.__class];
					if (klass) {
						return klass.getObjectPayload(this.object, 'essential');
					}
				}
				return this.object;
			}
			/* end same as dictionary */

			this.updateDict = function() {
				self.dictRequestEssentialDataJson = angular.toJson(self.getEssentialData())
				self.isDictLoading = true;
				return this.field.dict({
					filter:{},
					data: self.getEssentialData()
				}).then(function(items){
					if (self.reloadDict) {
						// nastapiła zmiana depends w czasie trwania request
						console.debug('Reloading dict', self.field.name)
						self.reloadDict = false;
						return self.updateDict();
					}
					self.setupObjects(items);
					self.isDictLoading = false;
				});
			}

			// update selection
			self.object[self.field.name] = self.object[self.field.name] || [];
			$scope.$watch(function(){return _.map(self.items, function(o){return {title:o.title,s:o.selected,o:o.value}})}, function(dict, old) {
				if (dict == old) return;
				if (!self.dictInitialized) return;
				self.object[self.field.name].length = 0;
				for (var i in self.items) {
					var r = self.items[i];
					if (r && r.selected) {
						var value = angular.copy(r.value)
						value[self.field.join.aheadref] = r.value[self.field.join.aheadref]
						self.object[self.field.name].push(value);
					}
				}
			}, true);
			

			// init
			if (this.field.depends) {
				var depends = $parse(this.field.depends);
				var getDepends = function() {
					var ret = depends(self.object);
					if (!ret) return [null];
					return ret.__class? [ret.__id] : (ret.length? ret : [ret]);
				}
				$scope.$watchCollection(getDepends, function(x){
					if (self.dictInitialized) self.updateDict();
					if (self.isDictLoading && self.dictRequestEssentialDataJson != angular.toJson(self.getEssentialData())) {
						self.reloadDict = true;
					} else if (!self.isDictLoading) {
						self.updateDict().then(self.setDefault);
					}
				});
				self.updateDict();
			} else {
				self.updateDict();
			}
			$scope.$watchCollection(function(){return self.object[self.field.name]}, function(values, old){
				if (values == old) return;
				if (!self.dictInitialized) return;
				var target_identity = (self.field.client && self.field.client.identity)? self.field.client.identity : '__vid';
				if (target_identity) {
					values = values.map(function(v){return v[self.field.join.aheadref][target_identity]});
				}
				for (var i in self.items) {
					var r = self.items[i];
					var target = target_identity? r.value[self.field.join.aheadref][target_identity] : r.value;
					r.selected = (values.indexOf(target) >= 0);
				}
			});
			$scope.$watchCollection(function(){return self.errors}, function(errors, old){
				if (errors == old) return;
				if (!self.dictInitialized) return;
				self.errorInitialized = false;
				self.setupObjects(self.loaded_objects);
			});


			// utility
			this.isFieldVisible = function(field, object) {
				var visible_test = $parse(field.visible);
				var visible = visible_test(object);
				return visible;
			}
			
			this.isFieldEditable = function(field) {
				var editable_test = $parse(field.editable);
				is_field_editable = editable_test(object);
				return is_field_editable;
			}


		},
		controllerAs: '$ref'
	}
}


var GridReferenceFieldCtrl = function($scope, FormNewInstanceFactory, $q, $controller, $parse, Classes, FieldTplDir) {

	var self = this;
	this.createMode = !$scope.object.__vid;
	this.Class = Classes[$scope.field.join.foreignClass];
	$scope.fieldTplDir = FieldTplDir
	
	this.dictInitialized = false;
	this.filter_depends = function(object) {
		var klass = object.getClass();
		return klass.getObjectPayload(object, 'essential');
	}

	this.items = [];
	
	var aheadref = $scope.field.join.aheadref;  // nazwa pola wskasujacego na zdalny obiekt
	var backref = $scope.field.join.backref;  // nazwa pola wskasujacego na ten obiekt
	var field = $scope.field;
	//var mod = ContextService.getContext(field.join.foreignClass);

	this.update_dict = function() {
		self.dictInitialized = false;
		return $scope.object.getClass()[$scope.field.name + '__dict']({
			//filter:Module.getFilterForContextField(fieldname)($scope.field.name),
			filter:{},
			data: self.filter_depends($scope.object)
		}).then(function(objects){
			console.log('GridReferenceFieldCtrl - dict', objects);
			self.items.length = 0;
			var newitems = [];
			for (var i=0; i<objects.length; i++) {
				var found = false;
				var ahead_id = objects[i].id;
				for (var c=0; c<($scope.object[field.name]||[]).length; c++) {
					var r = $scope.object[field.name][c];
					console.log('test ahead', ahead_id, r[aheadref]);
					if (r[aheadref] && ahead_id == r[aheadref].__id) {
						found = true;
						console.log('found!');
						r.__selected = true;
						r.__title = r[aheadref].__title;
						r[backref] = null;
						newitems.push(r);
					}
				}
				if (!found) {
					(function(target){
						var r = FormNewInstanceFactory.fetchNewInstance(field.join.foreignClass).then(function(object){  // todo - use ModuleService to create object with defaults
							object[aheadref] = target;
							object.__title = target.__title;
							return object;
						})
						newitems.push(r);
					})(objects[i]);
				}
				
			}
			return $q.all(newitems).then(function(items){
				self.dictInitialized = true;
				self.items = items;
			});
		});
	}
	
	$scope.$watch($scope.field.depends, function(x){
		var depends = $parse($scope.field.depends);
		var getDepends = function() {
			var ret = depends($scope.object);
			if (!ret) return [null];
			return ret.__class? [ret.__id] : (ret.length? ret : [ret]);
		}
		$scope.$watchCollection(getDepends, function(x){
			if ((!$scope.object || !$scope.object.id) && !self.createMode) return;
			if (self.dictInitialized) self.update_dict().then(self.set_default);
		});
	}, true);
	
	$scope.$watch('object.effective_time', function(ef_time){
		if ((!$scope.object || !$scope.object.id) && !self.createMode) return;
		if (self.dictInitialized) self.update_dict();
	}, true);

	// selection
	$scope.$watch(function(){return _.map(self.items, function(o){return {title:o.__title,s:o.__selected}})}, function(dict, old) {
		if (dict == old) return;
		if (!self.dictInitialized) return;
		$scope.object[field.name] = $scope.object[field.name] || [];
		$scope.object[field.name].length = 0;
		for (var i in self.items) {
			var r = self.items[i];
			if (r && r.__selected) $scope.object[field.name].push(r);
		}
	}, true);
	
	
	this.itemCtrl = function(Object) {
		var ctrl = $controller('ObjectController', {$scope:$scope.$new(), Object:Object, createMode:false});
		return ctrl;
	}
	
	this.update_dict();
	window.refCtrl = this;

}



angular.module('forms.fields.gridreference', [])
.controller('GridReferenceFieldCtrl', GridReferenceFieldCtrl)
.directive('gridReference', GridReference)
;
